<template>
    <Frame>
        <PageHeader :title="$t('comm.itemCodeQuery')" :hasBack="false" />
        <div class="list-contain">
            <div class="head-contain">

                <div class="filter-contain">
                    <span style="color:red;min-width: 85px;">ItemCode：</span>
                    <el-input v-model="itemCode" :placeholder="$t('salSalesOrder.inputpls')" size="small"
                        clearable></el-input>
                </div>

                <div class="filter-contain">
                    <span style="min-width: 56px;">{{ $t('itemCodeQuery.numberId') }}：</span>
                    <el-input-number v-model="numberId" :min="0" size="small"></el-input-number>
                </div>

                <div class="filter-contain">
                    <span>{{ $t('itemCodeQuery.length') }}：</span>
                    <el-input-number v-model="length" :min="0" size="small"></el-input-number>
                </div>

                <div class="filter-contain">
                    <span>{{ $t('itemCodeQuery.lenUnit') }}：</span>
                    <el-select v-model="lenUnit" placeholder="" class="typeSel" size="small">
                        <el-option v-for="item in lenUnitSel" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </div>

                <div class="filter-contain">
                    <span style="min-width: 85px;">{{ $t('itemCodeQuery.supplierId') }}</span>
                    <el-input v-model="supplierId" :placeholder="$t('salSalesOrder.inputpls')" size="small"
                        @change="getSupplier()" clearable></el-input>
                </div>

                <div class="filter-contain">
                    <span style="min-width: 56px;">{{ $t('itemCodeQuery.invoText') }}：</span>
                    <el-select size="small" v-model="invo">
                        <el-option v-for="item in yesNoList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                
                <!-- <div style="width: 74%;"> -->
                <div style="width: 49%;">
                    <span style="width: 100%;display: flex; justify-content: flex-end;">
                        <el-button type="reset" @click="reset()">{{ $t('button.reset') }}</el-button>
                        <el-button type="primary" @click="getListData()">{{ $t('button.query') }}</el-button>
                </span>
            </div>
            </div>
        </div>
        <el-table ref="multipleTable" :data="tableData" :height="tableHeight" style="margin:0;width:100%"
            v-loading="tableLoading">
            <el-table-column type="index" width="50" :label="$t('itemCodeQuery.rowNo')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_SupplyId', tableData)" prop="X_SupplyId"
                :label="$t('itemCodeQuery.supplier')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_BPMaterialId', tableData)" prop="X_BPMaterialId"
                label="ItemCode"></el-table-column>
            <el-table-column :min-width="WidthControl('X_BPMaterialName', tableData)" prop="X_BPMaterialName"
                label="ItemName"></el-table-column>
            <el-table-column :width="WidthControl('X_Length', tableData,3)" prop="X_Length" align="right"
                :label="$t('itemCodeQuery.length')"></el-table-column>
            <el-table-column :width="WidthControl('X_LUnitId', tableData,4)" prop="X_LUnitId"
                :label="$t('itemCodeQuery.lenUnit')"></el-table-column>
            <el-table-column :width="WidthControl('SQuantity', tableData,3)" prop="SQuantity" align="right"
                :label="$t('itemCodeQuery.numberId')"></el-table-column>
            <el-table-column :width="WidthControl('UnitId', tableData)" prop="UnitId"
                :label="$t('itemCodeQuery.unit')"></el-table-column>
            <el-table-column :width="WidthControl('X_SalDiscount', tableData)" prop="X_SalDiscount"
                :label="$t('itemCodeQuery.account')"></el-table-column>
            <el-table-column :width="WidthControl('X_SPrice', tableData)" prop="X_SPrice"
                :label="$t('itemCodeQuery.sUnitId')">
            </el-table-column>
            <el-table-column width="100" prop="X_CountFomu" :label="$t('itemCodeQuery.countFomu')">
                <template slot-scope="scope">
                    <span style="color:blue; cursor: pointer;" slot="reference" @click="showCountFomu(scope.$index);">{{$t('itemCodeQuery.watchFomu')}}</span>
                </template>
            </el-table-column>
        </el-table>
        <div class="footer-contain">
            <PageSizeChanger :pagesize="pageSize" :afterChange="pageSizeChange"></PageSizeChanger>
            <el-pagination ref="pagination" class="pagination" @current-change="handleCurrentChange"
                layout="total,prev,pager,next,jumper" :pager-count="pagecount" :current-page="currentPage"
                :total="totalCount" :page-size="pageSize">
            </el-pagination>
        </div>
        <el-dialog class="fomudialog" width="25%" :top="marginTop" :title="fomuTitle" :visible.sync="fomuvisible" :append-to-body="true" @opened="dialogOpened" @closed="dialogClosed">
            <span>{{ countFomu }}</span>
        </el-dialog>
    </Frame>
</template>
<script>
import { listMixin } from '@/agency/mixin/mixin.js'
export default {
    name: "ItemCodeQuery",
  mixins: [listMixin],
    data() {
        return {
            itemCode: '',//过滤条件
            supplierId: '',
            length: 0,
            lenUnit: '',
            lenUnitSel: [{
                value: "C",
                label: this.$t("itemCodeQuery.lenUnitSelC")
            },{
                value: "I",
                label: this.$t("itemCodeQuery.lenUnitSelI")
            }],
            numberId: 0,
            tableData: [],//当前页数据
            pageIndex: 0,
            totalCount: 0,
            tableLoading: false,
            resizeFlag: null,
            tableHeight: window.innerHeight - 320,
            pagecount: 5,
            fomuTitle: '',
            countFomu: '',
            fomuvisible: false,
            marginTop:"105px",
            invo:"true",
            yesNoList: [
                { value: "true", label: this.$t("comm.btnyes") },
                { value: "false", label: this.$t("comm.btnno") }
            ],
        }
    },
    props: {
        GetListData: {
            type: Function,
            default: function (pageIndex, ...arg) {
                this.getListData(pageIndex, ...arg);
            }
        }
    },
    mounted() {
        this.frameOnResize(320);
    },
    methods: {
        dialogClosed(){
            var dialogStyle=document.querySelector('.fomudialog .el-dialog');
            dialogStyle.style.marginRight='8px';
            var marginTop = 105 + 44 * this.index;
            dialogStyle.style.marginTop = marginTop + "px";
        },
        dialogOpened(){
            var dialog=document.querySelector('.fomudialog .el-dialog__header');
            var dialogStyle=document.querySelector('.fomudialog .el-dialog');
            var isDrag=false;
            var offsetX,offsetY;
            dialog.addEventListener('mousedown',(e)=>{
                isDrag=true;
                var oldRight=Number(dialogStyle.style.marginRight.split('px')[0]);
                if(oldRight==0) oldRight=8;
                var oldTop=Number(dialogStyle.style.marginTop.split('px')[0]);
                offsetX=e.clientX + oldRight;
                offsetY=e.clientY - oldTop;
                document.addEventListener('mouseup',onMouseUp);
                document.addEventListener('mousemove',onMouseMove);
            })
            function onMouseMove(e){
                if(isDrag){
                    const newRight = offsetX - e.clientX;
                    const newTop = e.clientY - offsetY;
                    dialogStyle.style.marginRight=newRight+'px';
                    dialogStyle.style.marginTop=newTop+'px';
                }
            }
            function onMouseUp(e){
                isDrag=false;
                document.removeEventListener('mousemove',onMouseMove);
                document.removeEventListener('mouseup',onMouseUp);
            }  
        },
        showCountFomu(index) {
            this.index=index;
            var rowNo = index + 1;
            if(rowNo<10) {
                rowNo="0"+rowNo;
            }
            this.fomuTitle = this.$t('itemCodeQuery.rowNo') + rowNo + this.$t('itemCodeQuery.countFomu') + ":";
            this.countFomu = this.tableData[index].X_CountFomu;
            this.fomuvisible = true;
            var marginTop = 105 + 44 * index;
            this.marginTop = marginTop + "px";
        },
        getSupplier() {
            if (this.supplierId && this.supplierId != "") {
                this.axiosInvoke(this.YMBillHandlerUrl, {
                    action: 'getsupname',
                    userId: this.supplierId
                }, (res) => {
                    var data = eval(res.data);
                    if (!data.userName) {
                        this.$alert(this.$t("itemCodeQuery.matchWarn"), this.$t("comm.tip"));
                        this.supplierId = "";
                    }
                })
            }
        },
        getListData(index) {
            if (!this.itemCode || this.itemCode == '') {
                this.$alert(this.$t("itemCodeQuery.inputCode"), this.$t("comm.tip"));
                return;
            }
            //长度不为空时，长度单位必填
            if (!!this.length && this.length / 1 > 0 && this.lenUnit == "") {
                this.$alert(this.$t("itemCodeQuery.lenUnitWarn"), this.$t("comm.tip"));
                return;
            }
            this.pageIndex = index;
            this.tableLoading = true;
            this.axiosInvoke(this.YMBillHandlerUrl, {
                action: 'itemcodequery',
                itemCode: this.itemCode,
                supplierId: this.supplierId,
                length: this.length,
                lenUnit: this.lenUnit,
                numberId: this.numberId,
                invo:this.invo,
                pageIndex: this.pageIndex,
                pageSize: this.$store.state.pagesize
            }, (res) => {
                const data = res.data;
                this.tableLoading = false;
                this.tableData = data.DataTable ? data.DataTable : [];
                this.totalCount = data.totalCount;
            }, false, true);
        },
        handleCurrentChange(page) {
            this.pageIndex = page - 1;
            this.GetListData(this.pageIndex);
        },
        pageSizeChange() {
            this.GetListData(0);
        },
        reset() {
            this.itemCode = "";
            this.supplierId = "";
            this.length = "";
            this.lenUnit = "";
            this.numberId = 1;
            this.tableData = [];
            this.pageIndex = 0;
            this.totalCount = 0;
        },
    }
}
</script>
<style scoped>
.list-contain {
    display: flex;
    padding: 10px 0px;
}

.head-contain {
    padding: 0 20px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}

.filter-contain {
    width: 24%;
    padding-right: 1%;
    display: flex;
    flex-wrap: nowrap;
    padding-bottom: 10px;
}

.filter-contain>span {
    color: black;
    font-size: 14px;
    margin: auto;
    white-space: nowrap;
}

.head-contain > div >span > .el-button{
  padding: 10px 18px;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner,
.el-input-number,
.el-select {
    width: 100%;
}

.el-table /deep/ .el-table__header .cell .el-checkbox:first-child {
    padding-left: 5px;
}

.footer-contain {
    display: flex;
    padding-top: 6px;
    justify-content: center;
}

.pagination {
    padding-top: 4px;
}

.el-table{
  font-size: 12px;
  color: black;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f9f9f9;
}

.el-table /deep/ thead {
    font-size: 14px;
    color: black;
}
.fomudialog /deep/ .el-dialog {
    margin-right: 8px;
    pointer-events: auto;
}
</style>
